import { RootState } from '../store';

import { IGeoLocationState } from './geo-location.slice';

export const selectGeoLocation = (state: RootState): IGeoLocationState => state.geoLocation;
